import { gql } from '@apollo/client';

export type GetFavoritesResponse = {
  userFavorites: {
    __typename: 'RestUserFavorites';
    data: {
      __typename: 'RestUserFavoritesData';
      attributes: {
        __typename: 'RestUserFavoritesAttributes';
        variantIds: number[];
      };
    };
  };
};

export const GET_FAVORITES_QUERY = gql`
  query GetFavoritesQuery {
    userFavorites @rest(type: "RestUserFavorites", endpoint: "user", path: "/likes") {
      data @type(name: "RestUserFavoritesData") {
        attributes @type(name: "RestUserFavoritesAttributes") {
          variantIds: variant_ids
        }
      }
    }
  }
`;

export const ADD_FAVORITE_MUTATION = gql`
  mutation AddFavoriteMutation($id: Int!) {
    addFavorite(id: $id, input: {})
      @rest(type: "RestAddFavorite", endpoint: "user", path: "/likes/{args.id}", method: "POST") {
      NoResponse
    }
  }
`;

export const REMOVE_FAVORITE_MUTATION = gql`
  mutation RemoveFavoriteMutation($id: Int!) {
    removeFavorite(id: $id)
      @rest(
        type: "RestRemoveFavorite"
        endpoint: "user"
        path: "/likes/{args.id}"
        method: "DELETE"
      ) {
      NoResponse
    }
  }
`;
